var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "message-view",
        { attrs: { show: _vm.showMessage } },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_3")) + "\n    ")
          ]),
          _c("template", { slot: "message" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_4")) + "\n    ")
          ]),
          _c(
            "template",
            { slot: "action" },
            [
              _c(
                "button-view",
                {
                  attrs: { type: "submit", variant: "center special" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.closeMessage()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message_6")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10a658d2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a658d2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact-response.vue
// module id = 595
// module chunks = 4